import {
  Card,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import React, { useState } from "react";
import { Toast } from "antd-mobile";
import { _ADD_ESTABLISHMENT } from "../../models/establishment";

const AddAward = (props) => {
  // State variables
  const [awardsName, setAwardsName] = useState("");
  const [awardsInstitution, setAwardsInstitution] = useState("");
  const [periodFrom, setPeriodFrom] = useState("");
  const [level, setLevel] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = () => {
    // Validate fields
    if (!awardsName || !awardsInstitution || !periodFrom || !level) {
      setErrorMessage("Please fill in all required fields.");
      return;
    }

    // Construct award details
    const awardData = {
      awards_name: awardsName,
      awards_institution: awardsInstitution,
      period_from: periodFrom,
      level,
      document: selectedFile,
    };
    _ADD_ESTABLISHMENT(taskData)
      .then((res) => {
        Toast.show({
          icon: "success",
          content: res.message ? res.message : "Data successfully saved!",
        });
        if (props.onSuccess) props.onSuccess();
      })
      .catch((error) => {
        console.error("Error saving data:", error);
        Toast.show({
          icon: "fail",
          content: "Error saving data. Please try again.",
        });
        if (props.onSuccess) props.onSuccess();
      });
  };

  return (
    <Card>
      <CardContent>
        {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
        <Grid container spacing={2}>
          {/* Awards Name */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Awards Name"
              value={awardsName}
              onChange={(e) => setAwardsName(e.target.value)}
              required
            />
          </Grid>

          {/* Awards Institution */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Awards Institution"
              value={awardsInstitution}
              onChange={(e) => setAwardsInstitution(e.target.value)}
              required
            />
          </Grid>

          {/* Period From */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="date"
              label="Period From"
              value={periodFrom}
              onChange={(e) => setPeriodFrom(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
          </Grid>

          {/* Level */}
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Level"
              value={level}
              onChange={(e) => setLevel(e.target.value)}
              required
            >
              <MenuItem value="">-Select-</MenuItem>
              <MenuItem value="international">International</MenuItem>
              <MenuItem value="national">National</MenuItem>
              <MenuItem value="state">State</MenuItem>
            </TextField>
          </Grid>

          {/* Upload Document */}
          <Grid item xs={12}>
            <input
              type="file"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              onChange={(e) => setSelectedFile(e.target.files[0])}
            />
            {selectedFile && (
              <>
                {["image/jpg", "image/jpeg", "image/png"].includes(
                  selectedFile.type
                ) ? (
                  <div>
                    <img
                      src={URL.createObjectURL(selectedFile)}
                      alt="Preview"
                      style={{
                        width: "180px",
                        height: "190px",
                        cursor: "pointer",
                      }}
                    />
                    <Button onClick={() => setSelectedFile(null)}>
                      Remove
                    </Button>
                  </div>
                ) : (
                  <div>
                    <a
                      href={URL.createObjectURL(selectedFile)}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#061277", fontWeight: "bold" }}
                    >
                      View Document
                    </a>
                    <Button onClick={() => setSelectedFile(null)}>
                      Remove
                    </Button>
                  </div>
                )}
              </>
            )}
          </Grid>

          {/* Actions */}
          <Grid item xs={12} textAlign="right">
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => (props.onSuccess ? props.onSuccess() : null)}
              style={{ marginRight: "10px" }}
            >
              Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Save Details
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AddAward;
